
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  security_token: any;
  price: any;
  creditBalance: any;

  constructor(private http: HttpClient, private UTS: UtilitiesService) { }

  setSecurityToken(token) {
    this.security_token = token;
  }
  getSecurityToken() {
    return this.security_token;
  }

  setprice(price) {
    this.price = price;
  }

  getPrice() {
    return this.price;
  }
  setCreditBalance(credit) {
    this.creditBalance = credit;
  }
  getCreditBalance() {
    return this.creditBalance;
  }
  readDocument(updateRequest: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    //  sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
    return this
      .http.post(environment.BASE_URL + "/readOCRKidsAddon.service", updateRequest, options).pipe(finalize(() => {
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }

  
  convertImageToPDFBase64(updateRequest: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    //  sessionStorage.setItem('cpSecurityToken',changePlanSecurityToken);
    return this
      .http.post(environment.BASE_URL + "/convertImageToPDFBase64.service", updateRequest, options).pipe(finalize(() => {
        // sessionStorage.removeItem('cpSecurityToken')
      }));
  }
  getCharges() {
    if (sessionStorage.getItem('amount') === null) {
      return '0';
    } else {
      return sessionStorage.getItem('amount');
    }


  }
}
